import { createFileRoute, redirect } from "@tanstack/react-router";

// Dashboard is the app's home now (`/`); keep old links working.
// `beforeLoad` redirects before anything renders, so there is no component.
export const Route = createFileRoute("/dashboard")({
  beforeLoad: () => {
    throw redirect({ to: "/", replace: true });
  },
});
